module.exports = __webpack_public_path__ + "img/rec-06.19c5453d.png";